/* eslint-disable react/display-name */
import React, { useState } from "react"
import Image from "next/image"
import { Container, Grid, Accordion, AccordionSummary, AccordionDetails } from "@mui/material"
import { makeStyles } from "makeStyles"
import Button from "components/Buttons/Button"
import Link from "components/i18n/Link"

import SEO from "components/SEO"
import { AiFillCheckCircle } from "react-icons/ai"
import { BsChevronDown } from "react-icons/bs"

import HeaderImage from "/images/services.jpeg"
import Chat from "svg/contact/chat.svg"

import Customers from "components/Customers"

const useStyles = makeStyles()((theme) => ({
	header: {
		textAlign: "center",
		minHeight: "400px",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		color: "white",
	},
	headerBgImage: {
		position: "absolute",
		top: 0,
		left: 0,
		height: "500px",
		width: "100%",
		overflow: "hidden",
		zIndex: -1,
		background: "#182F37",
	},
	card: {
		background: theme.palette.secondary.main,
		padding: 30,
		borderRadius: 5,
		transition: "0.4s",
		"&:hover": {
			background: theme.palette.secondary.light,
		},
	},
	buttonWidth: {
		maxWidth: 250,
		"@media only screen and (max-width: 960px)": {
			maxWidth: "100%",
		},
	},
	logosHeight: {
		height: 30,
		maxWidth: 130,
		"@media only screen and (max-width: 960px)": {
			height: 20,
		},
	},
}))

const services = [
	{
		icon: "",
		headline: "Bedienungsanleitungen",
		content:
			"Hier finden Sie die Anleitungen für die gängigsten Schlösser als PDF-Datei zum downloaden.",
		buttonText: "Anleitungen durchstöbern",
		href: "/manuals",
	},
	{
		icon: "",
		headline: "Ersatzteile bestellen",
		content:
			"Ist ein wichtiges Bauteil Ihres Tresors verloren gegangen? Wir helfen Ihnen das passende Ersatzteil zu finden.",
		buttonText: "Ersatzteile anfragen",
		href: "/spare-parts",
	},
	{
		icon: "",
		headline: "Produktregistrierung",
		content:
			"Registrieren Sie Ihr Produkt und sind immer auf dem neuesten Stand. Sie erhalten die neuesten Nachrichten und exklusive Angebote.",
		buttonText: "Produkt registrieren",
		href: "/register-products",
	},
]

const solutions = [
	{
		solution: <div>Architekten &amp; Planer</div>,
	},
	{
		solution: <div>Apotheken</div>,
	},
	{
		solution: <div>Automobilbranche</div>,
	},
	{
		solution: <div>Banken &amp; Versicherungen</div>,
	},
	{
		solution: <div>Behörden &amp; Öffentliche Verwaltungen</div>,
	},
	{
		solution: <div>Handel &amp; Filialisten</div>,
	},
	{
		solution: <div>Hotellerie &amp; Gastronomie</div>,
	},
]

const infos = [
	{
		question: "Wo kann ich Secureo Produkte kaufen?",
		answer: () => (
			<p>
				Sie erhalten unsere hochwertigen Tresore und Safes online auf{" "}
				<a style={{ textDecoration: "none" }} href="https://www.tresoro.de">
					Tresoro.de
				</a>
				,{" "}
				<a style={{ textDecoration: "none" }} href="https://www.tresoro.at">
					Tresoro.at
				</a>
				,{" "}
				<a style={{ textDecoration: "none" }} href="https://safehero.com">
					SafeHero.com
				</a>{" "}
				und{" "}
				<a
					style={{ textDecoration: "none" }}
					href="https://www.amazon.de/secureo"
					rel="nofollow"
				>
					Amazon
				</a>{" "}
				sowie auf Anfrage bei unserem Innendienst.
			</p>
		),
	},
	{
		question: "Warum sollte ich mich für einen Secureo Safe entscheiden?",
		answer: () => (
			<p>Große Auswahl, Günstige Preise, Gratis Lieferung, Sicheres Online-Shopping</p>
		),
	},
	{
		question: "Wo kann ich Ersatzteile bestellen?",
		answer: () => (
			<p>
				<Link style={{ color: "#009cac" }} href="/spare-parts">
					Hier
				</Link>{" "}
				können Sie ganz mühelos ein Ersatzteil online anfordern
			</p>
		),
	},
]

const ServicePage = () => {
	const { classes } = useStyles()
	const asPath = "/service"

	const [expanded, setExpanded] = useState(0)

	const handleChange = (panel) => (event, newExpanded) => {
		setExpanded(newExpanded ? panel : false)
	}

	return (
		<>
			<SEO asPath={asPath} title="Service" appendLocalizedShopNameWithPipe />
			<div className={classes.header}>
				<div className={classes.headerBgImage}>
					<Image
						alt="Service"
						src={HeaderImage}
						quality={100}
						fill
						sizes="100vw"
						style={{
							objectFit: "cover",
						}}
					/>
				</div>
				<div style={{ textShadow: "1px 1px 2px rgba(0, 0, 0, 0.4)" }}>
					<h1>Willkommen bei unserer Service Übersicht</h1>
					<p>Wir sind für Sie da!</p>
				</div>
			</div>
			<div style={{ background: "#182F37", color: "#fff", padding: "50px 0px" }}>
				<h2 style={{ textAlign: "center", marginBottom: 50 }}>Service</h2>
				<Container>
					<Grid container spacing={3}>
						{services.map((service) => {
							const { icon, headline, content, buttonText, href } = service
							return (
								<Grid item xs={12} sm={6} md={4} key={headline}>
									<div className={classes.card}>
										<div>{icon}</div>
										<h3 style={{ marginBottom: 0 }}>{headline}</h3>
										<p style={{ minHeight: 100 }}>{content}</p>
										<Link href={href}>
											<Button color="primary">{buttonText}</Button>
										</Link>
									</div>
								</Grid>
							)
						})}
					</Grid>
				</Container>
			</div>
			<div style={{ padding: "100px 0px 50px 0px" }}>
				<Container>
					<Grid container spacing={3}>
						<Grid item xs={12} sm={6}>
							<p style={{ color: "#009CAC", marginBottom: 0, fontSize: 18 }}>
								<strong>Branchenlösungen</strong>
							</p>
							<h2 style={{ fontSize: "28", marginTop: 0 }}>
								Wir bieten Sicherheitslösungen für eine Vielzahl an verschiedener
								Branchen
							</h2>
							<p>
								Durch unsere Erfahrung im Projektbereich bieten wir Ihnen
								maßgeschneiderte Lösungen für Ihr Projekt oder Unternehmen in
								Österreich, Deutschland und in der Schweiz. Wir bieten Ihnen eine
								kompetente Projektabwicklunge in den unterschiedlichsten Bereichen.
							</p>
							<div className={classes.buttonWidth}>
								<Link href="/contact">
									<Button color="primary">Kontaktieren Sie uns</Button>
								</Link>
							</div>
						</Grid>
						<Grid item xs={false} sm={1} />
						<Grid item xs={12} sm={5}>
							<ul style={{ listStyle: "none", paddingLeft: 0, marginTop: 70 }}>
								{solutions.map((solution, i) => {
									return (
										<li
											key={i}
											style={{
												display: "flex",
												alignItems: "center",
												marginBottom: 10,
											}}
										>
											<AiFillCheckCircle
												color="green"
												size="1.2rem"
												style={{ marginRight: 5 }}
											/>
											{solution.solution}
										</li>
									)
								})}
							</ul>
						</Grid>
						<Grid item xs={12}>
							<Customers hasDarkBackground={false} />
						</Grid>
					</Grid>
				</Container>
			</div>
			<div style={{ background: "#182F37", color: "#fff", padding: "100px 0px" }}>
				<Container>
					<Grid container spacing={3}>
						<Grid item xs={12} sm={6}>
							{infos.map((info, i) => {
								const Answer = info.answer
								return (
									<Accordion
										square
										key={info.question}
										style={{
											background: "none",
											boxShadow: "none",
											color: "#fff",
											borderBottom: "1px solid rgba(255,255,255, 0.3)",
										}}
										onChange={handleChange(i)}
										expanded={expanded === i}
									>
										<AccordionSummary
											expandIcon={
												<BsChevronDown size="1.2rem" color="#fff" />
											}
											aria-controls="panel1a-content"
											id="panel1a-header"
										>
											<div>
												<strong>{info.question}</strong>
											</div>
										</AccordionSummary>
										<AccordionDetails>
											<div>
												<Answer />
											</div>
										</AccordionDetails>
									</Accordion>
								)
							})}
						</Grid>
						<Grid item xs={12} sm={6}>
							<div style={{ position: "relative", width: "100%" }}>
								<div style={{ width: "100%" }}>
									<Chat style={{ padding: 70, maxHeight: 400 }} />
								</div>
								<Link href="/contact">
									<div
										style={{
											background: "#009CAC",
											borderRadius: 5,
											padding: 25,
											position: "absolute",
											top: "50%",
											left: "50%",
											transform: "translate(-50%, -50%)",
											boxShadow: "0 10px 10px rgba(0,0,0,0.11)",
											minWidth: 250,
										}}
									>
										<div>
											<strong>Kontaktformular</strong>
										</div>
										<div style={{ display: "flex", alignItems: "flex-end" }}>
											<div style={{ marginTop: 15 }}>
												Schnell und einfach unser Kontaktformular benutzen
											</div>
											<div style={{ marginLeft: 10 }}>&#x27F6;</div>
										</div>
									</div>
								</Link>
							</div>
							<div style={{ color: "fff" }}>
								<strong>
									Haben Sie noch Fragen? Erreichen Sie uns ganz einfach über unser
									Kontaktformular!
								</strong>
							</div>
						</Grid>
					</Grid>
				</Container>
			</div>
		</>
	)
}

export default ServicePage
